var Handlebars = require("../../../../../node_modules/.pnpm/handlebars@4.7.10/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data) {
    return "checked";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"infoboard-title\">"
    + alias2(__default(require("./i18n.js")).call(alias1,"Common.Restriction",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":29},"end":{"line":1,"column":58}}}))
    + "</div>\n<fieldset>\n    <section class=\"form-group col-xs-12\">\n        <div class=\"col-xs-12\">\n            <label>\n                <input type=\"checkbox\" class=\"form-control flat\" name=\"IsRestrict\" value=\"true\" "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"information") : depth0)) != null ? lookupProperty(stack1,"isRestrict") : stack1),{"name":"if","hash":{},"fn":container.program(0, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":96},"end":{"line":6,"column":140}}})) != null ? stack1 : "")
    + "> "
    + alias2(__default(require("./i18n.js")).call(alias1,"Common.RestrictPoint",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":6,"column":142},"end":{"line":6,"column":173}}}))
    + "\n            </label>\n        </div>\n    </section>\n</fieldset>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/scripts/core/templates/templates/points-edit-restriction.hbs
// module id = 4hWa
// module chunks = 1